module.exports = __webpack_public_path__ + "img/vip.5fad0a29.png";